import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLD from "@/components/base/JsonLD";
import Breadcrumb from "@/components/base/Breadcrumb";
import { useNavigate } from "react-router-dom";

const doradca360Schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Expert Kredytowy – kompleksowa analiza finansowa 360° | EXPERT KREDYTOWY",
  description:
    "Expert Kredytowy — Twoje finanse pod pełną kontrolą. Kompleksowa analiza, dobór ofert z 20+ banków, wsparcie na każdym etapie. Bezpłatna konsultacja. Sanok, Podkarpacie.",
  url: "https://kredytpodkarpacie.pl/doradca360",
  isPartOf: {
    "@type": "WebSite",
    name: "EXPERT KREDYTOWY",
    url: "https://kredytpodkarpacie.pl",
  },
};

const features = [
  {
    icon: "ri-search-eye-line",
    title: "Analiza 360°",
    desc: "Sprawdzam Twoją sytuację finansową ze wszystkich stron — dochody, zobowiązania, historia kredytowa, plany na przyszłość.",
  },
  {
    icon: "ri-bank-line",
    title: "20+ banków w jednym miejscu",
    desc: "Porównuję oferty z ponad 20 banków. Nie musisz biegać po placówkach — ja robię to za Ciebie.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Dokumentacja bez stresu",
    desc: "Pomagam skompletować wszystkie dokumenty. Wiem dokładnie czego wymaga każdy bank i przygotowuję Cię na każdy etap.",
  },
  {
    icon: "ri-hand-coin-line",
    title: "Negocjacje warunków",
    desc: "Walczę o lepsze oprocentowanie, niższą prowizję i korzystniejsze warunki. Banki znają mnie — Ty zyskujesz.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Bezpieczeństwo i poufność",
    desc: "Twoje dane są u mnie bezpieczne. Działam zgodnie z RODO, a wszystkie informacje zostają między nami.",
  },
  {
    icon: "ri-phone-line",
    title: "Wsparcie 7 dni w tygodniu",
    desc: "Jestem dostępny gdy mnie potrzebujesz. Telefon, e-mail, spotkanie — wybierasz formę kontaktu.",
  },
];

const steps = [
  {
    step: "01",
    title: "Konsultacja wstępna",
    desc: "Rozmowa o Twoich potrzebach, planach i możliwościach. Bezpłatna i bez zobowiązań — poznajemy się i ustalamy strategię.",
    icon: "ri-chat-1-line",
  },
  {
    step: "02",
    title: "Analiza finansowa 360°",
    desc: "Dokładna analiza dochodów, wydatków, zobowiązań i zdolności kredytowej. Tworzę pełny obraz Twojej sytuacji finansowej.",
    icon: "ri-pie-chart-line",
  },
  {
    step: "03",
    title: "Dobór i porównanie ofert",
    desc: "Przeglądam oferty z 20+ banków, porównuję warunki i wybieram te najlepiej dopasowane do Ciebie. Dostajesz konkretne liczby i rekomendacje.",
    icon: "ri-scales-3-line",
  },
  {
    step: "04",
    title: "Złożenie wniosku i decyzja",
    desc: "Kompletuję dokumentację, składam wnioski i monitoruję proces. Jestem z Tobą aż do finalnej decyzji kredytowej i wypłaty środków.",
    icon: "ri-task-line",
  },
];

export default function Doradca360Page() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={doradca360Schema} />
      <Navbar />

      <div className="pt-16 md:pt-20">
        <div className="px-4 md:px-8 lg:px-12 mb-4">
          <Breadcrumb />
        </div>

        {/* Hero */}
        <section className="relative bg-foreground-950 text-white overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none" />
          <div className="relative z-10 mx-auto max-w-[1440px] px-4 py-14 md:px-8 md:py-20 lg:px-16 lg:py-24 xl:px-20">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
              <div className="flex-1 text-center">
                <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-primary-400 mb-3">
                  Nowe podejście do finansów
                </div>
                <h1 className="mx-auto mb-4 max-w-xl font-heading text-2xl font-bold leading-tight text-white md:text-3xl lg:text-4xl xl:text-5xl">
                  <span className="text-primary-400">Expert Kredytowy</span>
                  <span className="text-accent-400">360</span> — Twoje finanse pod pełną kontrolą
                </h1>
                <p className="mx-auto mb-8 max-w-lg text-sm leading-relaxed text-white/60 md:text-base">
                  Kompleksowa analiza finansowania w jednym miejscu. Analizuję Twoją sytuację ze wszystkich stron, dobieram najlepsze oferty i prowadzę Cię przez cały proces — od pierwszej rozmowy po finalną decyzję.
                </p>
                <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
                  <a
                    href="tel:698084044"
                    className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-primary-500 text-white font-bold text-sm rounded-full hover:bg-primary-600 transition-all hover:-translate-y-0.5 shadow-lg shadow-primary-500/20 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line text-lg" />
                    Zadzwoń: 698 084 044
                  </a>
                  <button
                    onClick={() => {
                      navigate("/kontakt");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/20 text-white font-semibold text-sm rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-mail-line" />
                    Formularz kontaktowy
                  </button>
                </div>
                <div className="mt-6 flex flex-wrap justify-center gap-4">
                  {["Bezpłatna konsultacja", "20+ banków", "25 lat doświadczenia"].map((t) => (
                    <span key={t} className="flex items-center gap-1.5 text-xs text-white/45">
                      <i className="ri-check-line text-green-400 text-sm" />
                      {t}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex-shrink-0 w-full max-w-[360px] lg:max-w-[420px]">
                <div className="relative">
                  <div className="absolute -inset-1 bg-gradient-to-br from-primary-500/30 to-accent-500/30 rounded-3xl blur-xl" />
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20modern%20financial%20advisor%20concept%20with%20abstract%20360%20degree%20circle%20made%20of%20interconnected%20lines%20and%20nodes%20representing%20comprehensive%20financial%20analysis%2C%20clean%20minimalist%20composition%2C%20warm%20charcoal%20background%20with%20subtle%20gold%20and%20copper%20accents%2C%20corporate%20yet%20friendly%20aesthetic%2C%20soft%20diffused%20lighting%2C%20editorial%20style%20photography&width=840&height=840&seq=doradca360-hero-01&orientation=squarish"
                    alt="Expert Kredytowy – kompleksowa analiza finansowania"
                    className="relative rounded-2xl w-full h-auto object-cover aspect-square"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Grid */}
        <section className="py-12 md:py-16 lg:py-20 bg-background-50">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <div className="text-center mb-10 md:mb-14">
              <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-primary-500 mb-3">
                Co zyskujesz
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                Pełen zakres usług w modelu 360°
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
                Od analizy przez dobór ofert po negocjacje z bankiem — wszystko w jednym miejscu, bez chodzenia po placówkach.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="group bg-white rounded-2xl border border-background-200 p-6 md:p-7 hover:border-primary-200 transition-all"
                >
                  <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors">
                    <i className={`${f.icon} text-lg text-primary-600 group-hover:text-white transition-colors`} />
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2">
                    {f.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process */}
        <section className="py-12 md:py-16 lg:py-20 bg-background-100">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <div className="text-center mb-10 md:mb-14">
              <div className="text-[11px] font-bold tracking-[0.2em] uppercase text-primary-500 mb-3">
                Jak to działa
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                Prosta droga do lepszych finansów
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
                Cztery kroki dzielą Cię od najlepszej oferty dopasowanej do Twoich potrzeb. Bez zbędnej papierologii i stresu.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {steps.map((s, i) => (
                <div key={s.step} className="relative group">
                  <div className="bg-white rounded-2xl border border-background-200 p-6 md:p-7 hover:border-primary-200 transition-all h-full">
                    <div className="text-5xl font-bold text-background-300 group-hover:text-primary-100 transition-colors mb-3 font-heading">
                      {s.step}
                    </div>
                    <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-500 transition-colors">
                      <i className={`${s.icon} text-base text-primary-600 group-hover:text-white transition-colors`} />
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2">
                      {s.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                  {i < steps.length - 1 && (
                    <div className="hidden lg:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10">
                      <i className="ri-arrow-right-line text-2xl text-background-300" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-12 md:py-16 lg:py-20 bg-background-50">
          <div className="mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
            <div className="bg-foreground-950 rounded-2xl p-8 md:p-12 lg:p-14 text-center relative overflow-hidden">
              <div className="absolute -right-20 -top-20 w-60 h-60 rounded-full bg-primary-500/10 blur-3xl pointer-events-none" />
              <div className="absolute -left-20 -bottom-20 w-60 h-60 rounded-full bg-accent-500/10 blur-3xl pointer-events-none" />
              <div className="relative z-10">
                <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3">
                  Gotowy na finansowe 360°?
                </h2>
                <p className="text-sm text-white/60 max-w-lg mx-auto mb-8 leading-relaxed">
                  Pierwsza konsultacja jest bezpłatna i niezobowiązująca. Porozmawiajmy o Twoich potrzebach — znajdę rozwiązanie dopasowane do Ciebie.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <a
                    href="tel:698084044"
                    className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-primary-500 text-white font-bold text-sm rounded-full hover:bg-primary-600 transition-all hover:-translate-y-0.5 shadow-lg shadow-primary-500/20 whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line text-lg" />
                    698 084 044
                  </a>
                  <button
                    onClick={() => {
                      navigate("/kontakt");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/20 text-white font-semibold text-sm rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-mail-line" />
                    Napisz wiadomość
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <p className="mx-auto max-w-[1440px] px-4 py-4 text-center text-[10px] text-foreground-400 md:px-8 lg:px-16 xl:px-20">
        Zabrania się kopiowania i wykorzystywania | Orsonet Studio 2026
      </p>
      <Footer />
    </div>
  );
}
